import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { ViewAccounts } from './views/accounts';
import { ViewLogin } from './views/login';
import { Policy } from './views/policy';
import { TermsAndConditions } from './views/termsAndConditions';

function App() {
  const [isLoggedIn, setLoggedIn] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const isPolicyPage =
    location.pathname === '/privacypolicy' || location.pathname === '/termsandconditions';

  return (
    <ThemeProvider theme={theme}>
      {isPolicyPage ? (
        <main id="scroll-root" className="mx-auto mt-10 px-4">
          <div className="bg-white px-8 py-10">
            {location.pathname === '/privacypolicy' ? <Policy /> : <TermsAndConditions />}
          </div>
        </main>
      ) : !isLoggedIn ? (
        <ViewLogin setLoggedIn={setLoggedIn} masterEmail={setEmail} />
      ) : (
        <main id="scroll-root" className="mx-auto mt-10 px-4">
          <div className="bg-white px-8 py-10">
            {/* @ts-ignore */}
            <ViewAccounts email={email} />
          </div>
        </main>
      )}
    </ThemeProvider>
  );
}

export default App;
